
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/szukaj",
      function () {
        return require("private-next-pages/szukaj.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/szukaj"])
      });
    }
  